// extracted by mini-css-extract-plugin
export default {"goldLine":"GoldLine_goldLine__asCZI"};